import React from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { Field, ErrorMessage, FieldArray } from "formik";
import CustomForm from "../../../../components/customcomponents/CustomForm";
import { Icon } from "@iconify/react";

const Step3PricingAndRooms = ({
    values,
    setFieldValue,
    submitted,
    errors,
    t,
    roomTypee,
    setroomTypee,
    setCurrentRoomIndex,
    currentRoomIndex,
    handleAddRoom,
    handleRemoveRoom,
}) => {
    return (
        <div>
            <Row>
                <Col md={3} className="mb-3">
                    <CustomForm
                        color={"#222528"}
                        type="number"
                        name="price_for_weekends"
                        lableText={t("AddProperties.weekendPrice")}
                        placeholderText={t("AddProperties.enterWeekendPrice")}
                        onChange={(e) =>
                            setFieldValue("price_for_weekends", e.target.value)
                        }
                        value={values.price_for_weekends}
                    />
                    {submitted && errors.price_for_weekends && (
                        <ErrorMessage
                            name="price_for_weekends"
                            component="div"
                            className="errorStyle"
                        />
                    )}
                </Col>
                <Col md={3} className="mb-3">
                    <CustomForm
                        color={"#222528"}
                        type="number"
                        name="weekend_discounted_price"
                        lableText={t("AddProperties.weekendDiscountedPrice")}
                        placeholderText={t(
                            "AddProperties.weekendDiscountedPricePlaceholder"
                        )}
                        onChange={(e) =>
                            setFieldValue("weekend_discounted_price", e.target.value)
                        }
                        value={values.weekend_discounted_price}
                    />
                    {submitted && errors.weekend_discounted_price && (
                        <ErrorMessage
                            name="weekend_discounted_price"
                            component="div"
                            className="errorStyle"
                        />
                    )}
                </Col>
                <Col md={3} className="mb-3">
                    <CustomForm
                        color={"#222528"}
                        type="number"
                        name="price_for_weekdays"
                        lableText={t("AddProperties.weekdayPrice")}
                        placeholderText={t("AddProperties.enterWeekdayPrice")}
                        onChange={(e) =>
                            setFieldValue("price_for_weekdays", e.target.value)
                        }
                        value={values.price_for_weekdays}
                    />
                    {submitted && errors.price_for_weekdays && (
                        <ErrorMessage
                            name="price_for_weekdays"
                            component="div"
                            className="errorStyle"
                        />
                    )}
                </Col>
                <Col md={3} className="mb-3">
                    <CustomForm
                        color={"#222528"}
                        type="number"
                        name="weekdays_discounted_price"
                        lableText={t("AddProperties.weekdayDiscountedPrice")}
                        placeholderText={t("AddProperties.enterWeekdayDiscountedPrice")}
                        onChange={(e) =>
                            setFieldValue("weekdays_discounted_price", e.target.value)
                        }
                        value={values.weekdays_discounted_price}
                    />
                    {submitted && errors.weekdays_discounted_price && (
                        <ErrorMessage
                            name="weekdays_discounted_price"
                            component="div"
                            className="errorStyle"
                        />
                    )}
                </Col>
            </Row>
            <Form className="radioFlex mb-3">
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Field
                        inline
                        name="room_type"
                        type="radio"
                        value="single"
                        as={Form.Check}
                        id="single-room"
                        onChange={() => {
                            setFieldValue("room_type", "single");
                            setroomTypee("single");
                            setCurrentRoomIndex(0);
                        }}
                        checked={roomTypee == "single"}
                    />
                    <label htmlFor="single-room" style={{ cursor: "pointer" }}>
                        {" "}
                        {t("AddProperties.singleRoomProperty")}
                    </label>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Field
                        inline
                        type="radio"
                        value="multi"
                        as={Form.Check}
                        id="multi-room"
                        onChange={() => {
                            setFieldValue("room_type", "multi");
                            setroomTypee("multi");
                            setCurrentRoomIndex(0);
                        }}
                        checked={roomTypee == "multi"}
                    />
                    <label htmlFor="multi-room" style={{ cursor: "pointer" }}>
                        {" "}
                        {t("AddProperties.multiRoomProperty")}
                    </label>
                </div>
            </Form>
            <FieldArray name="rooms">
                {({ push, remove, form }) => {
                    const { rooms } = form.values;
                    return (
                        <div>
                            <div className="roomFlex">
                                {values.room_type == "multi" && (
                                    <>
                                        {rooms.map((room, index) => (
                                            <>
                                                <div key={index} className="roomButtonWrapper">
                                                    <Button
                                                        className={`${submitted &&
                                                            errors?.rooms &&
                                                            errors?.rooms[index]
                                                            ? "errorborder"
                                                            : ""
                                                            } ${index == currentRoomIndex
                                                                ? "activeroombtn"
                                                                : "nonactiveroombtn"
                                                            }`}
                                                        onClick={() => setCurrentRoomIndex(index)}
                                                    >
                                                        {t("AddProperties.room")} {index + 1}
                                                    </Button>
                                                    <Icon
                                                        icon="carbon:close-filled"
                                                        fontSize={20}
                                                        className="cross"
                                                        color="#000000"
                                                        onClick={() => handleRemoveRoom(remove, index)}
                                                    />
                                                </div>
                                            </>
                                        ))}

                                        <Button
                                            className="active addFull"
                                            onClick={() => handleAddRoom(push)}
                                        >
                                            + {t("AddProperties.addNewRoom")}
                                        </Button>
                                    </>
                                )}
                            </div>
                            {rooms.map(
                                (room, index) =>
                                    index === currentRoomIndex && (
                                        <div key={index}>
                                            <Row>
                                                <Col md={6} className="mb-3">
                                                    <CustomForm
                                                        color={"#222528"}
                                                        type="number"
                                                        name={`rooms[${index}].numberOfBeds`}
                                                        lableText={t("AddProperties.numberOfBeds")}
                                                        placeholderText={t(
                                                            "AddProperties.enterNumberOfBeds"
                                                        )}
                                                        onChange={(e) =>
                                                            setFieldValue(
                                                                `rooms[${index}].numberOfBeds`,
                                                                e.target.value
                                                            )
                                                        }
                                                        value={values?.rooms[index]?.numberOfBeds}
                                                    />
                                                    {submitted &&
                                                        errors?.rooms?.length &&
                                                        errors?.rooms[index]?.numberOfBeds && (
                                                            <ErrorMessage
                                                                name={`rooms[${index}].numberOfBeds`}
                                                                component="div"
                                                                className="errorStyle"
                                                            />
                                                        )}
                                                </Col>
                                                <Col md={6} className="mb-3">
                                                    <CustomForm
                                                        color={"#222528"}
                                                        type="number"
                                                        name={`rooms[${index}].size`}
                                                        lableText={t("AddProperties.sizeInSqm")}
                                                        placeholderText={t("AddProperties.enterSize")}
                                                        onChange={(e) =>
                                                            setFieldValue(
                                                                `rooms[${index}].size`,
                                                                e.target.value
                                                            )
                                                        }
                                                        value={values?.rooms[index]?.size}
                                                    />
                                                    {submitted &&
                                                        errors?.rooms?.length &&
                                                        errors?.rooms[index]?.size && (
                                                            <ErrorMessage
                                                                name={`rooms[${index}].size`}
                                                                component="div"
                                                                className="errorStyle"
                                                            />
                                                        )}
                                                </Col>
                                            </Row>
                                            <Form.Label>{t("AddProperties.guests")}</Form.Label>
                                            <div className="quBox quBox1 mb-0">
                                                <div>
                                                    <span>{t("filter.adults")}</span>
                                                    <div className="pro_counter">
                                                        <div className="icon_Pro">
                                                            <Icon
                                                                onClick={() =>
                                                                    setFieldValue(
                                                                        `rooms[${index}].adults`,
                                                                        Math.max(
                                                                            parseInt(
                                                                                values?.rooms[index]?.adults
                                                                            ) - 1,
                                                                            0
                                                                        )
                                                                    )
                                                                }
                                                                color="#000000"
                                                                icon="clarity:minus-line"
                                                            />
                                                        </div>
                                                        <span>{values?.rooms[index]?.adults}</span>
                                                        <div className="icon_Pro">
                                                            <Icon
                                                                onClick={() =>
                                                                    setFieldValue(
                                                                        `rooms[${index}].adults`,
                                                                        values?.rooms[index]?.adults + 1
                                                                    )
                                                                }
                                                                color="#000000"
                                                                icon="basil:plus-outline"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <span>{t("AddProperties.children")}</span>
                                                    <div className="pro_counter">
                                                        <div className="icon_Pro">
                                                            <Icon
                                                                onClick={() =>
                                                                    setFieldValue(
                                                                        `rooms[${index}].children`,
                                                                        Math.max(
                                                                            parseInt(
                                                                                values?.rooms[index]?.children || "0",
                                                                                10
                                                                            ) - 1,
                                                                            0
                                                                        )
                                                                    )
                                                                }
                                                                color="#000000"
                                                                icon="clarity:minus-line"
                                                            />
                                                        </div>
                                                        <span>{values?.rooms[index]?.children}</span>
                                                        <div className="icon_Pro">
                                                            <Icon
                                                                onClick={() =>
                                                                    setFieldValue(
                                                                        `rooms[${index}].children`,
                                                                        values?.rooms[index]?.children + 1
                                                                    )
                                                                }
                                                                color="#000000"
                                                                icon="basil:plus-outline"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <span>{t("AddProperties.pets")}</span>
                                                    <div className="pro_counter">
                                                        <div className="icon_Pro">
                                                            <Icon
                                                                onClick={() =>
                                                                    setFieldValue(
                                                                        `rooms[${index}].pets`,
                                                                        Math.max(
                                                                            parseInt(
                                                                                values?.rooms[index]?.pets
                                                                            ) - 1,
                                                                            0
                                                                        )
                                                                    )
                                                                }
                                                                color="#000000"
                                                                icon="clarity:minus-line"
                                                            />
                                                        </div>
                                                        <span>{values?.rooms[index].pets}</span>
                                                        <div className="icon_Pro">
                                                            <Icon
                                                                onClick={() =>
                                                                    setFieldValue(
                                                                        `rooms[${index}].pets`,
                                                                        values?.rooms[index]?.pets + 1
                                                                    )
                                                                }
                                                                color="#000000"
                                                                icon="basil:plus-outline"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {submitted &&
                                                errors?.rooms?.length &&
                                                errors?.rooms[index]?.adults && (
                                                    <ErrorMessage
                                                        name={`rooms[${index}].adults`}
                                                        component="div"
                                                        className="errorStyle"
                                                    />
                                                )}
                                        </div>
                                    )
                            )}
                        </div>
                    );
                }}
            </FieldArray>
        </div>
    );
};

export default Step3PricingAndRooms;
